import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "redux/authReducer";
import { getUserInfo, getIsVLChatEnabled } from "redux/User/selectors";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import Cookies from "js-cookie";
// TODO: VL-6033 - re-write the vl_chat FE by FE engineers to:
// fe/clustplorer/src/views/components/VLChat/index.ts
import { VLChatWrapper } from "views/components/VLChat";

import {
  PRIVATE_DATASETS_PATH,
  PUBLIC_DATASETS_PATH,
} from "helpers/constants/paths";
import { initAmplitude } from "helpers/utility/amplitude";

import Layout from "views/layout";
import Login from "views/pages/Login";
import DatasetInventory from "views/pages/DatasetInventory";
import DataPage from "views/pages/DataPage";
import MobileScreenErrorModal from "views/modals/MobileScreenErrorModal";
import DatasetCreationPage from "views/pages/DatasetCreationPage";

import "./App.scss";
import { fetchUserConfig, fetchUserInfo } from "redux/User/actions";
import { isFastdupUser } from "helpers/utility/utilities";
import ErrorComponent from "views/layout/ErrorComponent";
import EnrichmentPage from "views/pages/EnrichmentPage";
import SavedViewsPage from "views/pages/SavedViewsPage";
import LoginLayout from "views/components/LoginLayout";
import FreeTrialPage from "views/pages/FreeTrialPage";
import ThankYouPage from "views/pages/ThankYouPage";
import { getDataset } from "redux/SingleDataset/selectors";
import BrowserSupportModal from "views/modals/BrowserSupportModal";

const LoginRouter = () => {
  const router = createBrowserRouter(
    createRoutesFromElements(
      <Route element={<LoginLayout />}>
        <Route path="/free-trial" element={<FreeTrialPage />} />
        <Route path="/thank-you" element={<ThankYouPage />} />
        <Route
          path="/login"
          element={<Login />}
          errorElement={<ErrorComponent />}
        />
      </Route>
    )
  );
  return <RouterProvider router={router} />;
};

const DataPageRouter = () => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<Layout />} errorElement={<ErrorComponent />}>
        <Route
          path="/dataset/:datasetId/data"
          element={<DataPage />}
          errorElement={<ErrorComponent />}
        />
        <Route
          path="/dataset/:datasetId/data/cluster/:clusterId"
          element={<DataPage />}
          errorElement={<ErrorComponent />}
        />
        <Route
          path="/dataset/:datasetId/data/image/:imageId"
          element={<DataPage />}
          errorElement={<ErrorComponent />}
        />
      </Route>
    )
  );
};

const DataAndLegacyRouter = () => {
  return createBrowserRouter(
    createRoutesFromElements(
      <Route path="/" element={<Layout />} errorElement={<ErrorComponent />}>
        <Route
          path="/"
          element={<DatasetInventory />}
          errorElement={<ErrorComponent />}
        />
        <Route
          path={PRIVATE_DATASETS_PATH}
          element={<DatasetInventory />}
          errorElement={<ErrorComponent />}
        />
        <Route
          path={PUBLIC_DATASETS_PATH}
          element={<DatasetInventory />}
          errorElement={<ErrorComponent />}
        />
        <Route path="/dataset/:datasetId/data" element={<DataPage />} />
        <Route
          path="/dataset/:datasetId/data/seed/:seedId"
          element={<DataPage />}
        />
        <Route
          path="/dataset/:datasetId/data/cluster/:clusterId"
          element={<DataPage />}
        />
        <Route
          path="/dataset/:datasetId/data/image/:imageId"
          element={<DataPage />}
        />
        <Route
          path="/dataset/:newDatasetId/create"
          element={<DatasetCreationPage />}
        />
        <Route
          path="/dataset/:enrichDatasetId/enrich"
          element={<EnrichmentPage />}
        />
        <Route
          path="/dataset/:viewsDatasetId/views"
          element={<SavedViewsPage />}
        />
      </Route>
    )
  );
};

const WrappedRoutes = () => {
  return (
    <RouterProvider
      router={isFastdupUser() ? DataPageRouter() : DataAndLegacyRouter()}
    />
  );
};

const RouterApp = () => {
  const dispatch = useDispatch();
  const pathname = window.location.pathname.split("/")[1];
  const isLoginRoute = ["free-trial", "thank-you", "login"].includes(pathname);
  const [user, setUser] = useState(selectUser());
  const userInfo = useSelector(getUserInfo);
  const dataset = useSelector(getDataset);
  const datasetId = dataset?.id;
  const isVLChatEnabled = useSelector(getIsVLChatEnabled);

  useEffect(() => {
    (async () => {
      await dispatch(fetchUserConfig() as any);
      const currentUser = selectUser();
      if (!user) {
        setUser(currentUser);
      }
    })();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (user) {
      dispatch(fetchUserInfo(user) as any);
    }
  }, [user, dispatch]);

  initAmplitude();

  // Get the user authentication token
  const userToken =
    user?.session || Cookies.get("SESSION") || Cookies.get("user_token");

  return (
    // TODO: VL-6033 - re-write the vl_chat FE by FE engineers to:
    // fe/clustplorer/src/views/components/VLChat/index.ts
    <VLChatWrapper
      datasetId={datasetId}
      userInfo={userInfo}
      userToken={userToken}
      isEnabled={isVLChatEnabled}
    >
      <BrowserSupportModal />
      <MobileScreenErrorModal />
      {isLoginRoute ? <LoginRouter /> : <WrappedRoutes />}
    </VLChatWrapper>
  );
};

export default RouterApp;
